import namespace from "@rdfjs/namespace";
const builder = namespace("http://www.ics.forth.gr/isl/CRMdig/");
export const strict = builder;
export const loose = builder;
